import { render } from "./BaseInputApp.vue?vue&type=template&id=459f99e8"
import script from "./BaseInputApp.vue?vue&type=script&lang=js"
export * from "./BaseInputApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__